/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddExamParticipantsRequestDto } from '../models';
// @ts-ignore
import type { AddStageParticipantsResultDto } from '../models';
// @ts-ignore
import type { ExamParticipantsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantExamSummaryStatusDto } from '../models';
/**
 * ExamParticipantApi - axios parameter creator
 * @export
 */
export const ExamParticipantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds participants to the exam stage by their certification stage participant IDs. Employees without a passed TEST stage in this certification are not added — they are reported in `skippedItems` with `reason = TEST_NOT_PASSED` (the `identifier` is the source `participantId` that was supplied). 
         * @summary Add participants to exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddExamParticipantsRequestDto} addExamParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamParticipants: async (certificationId: number, stageId: number, addExamParticipantsRequestDto: AddExamParticipantsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addExamParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addExamParticipants', 'stageId', stageId)
            // verify required parameter 'addExamParticipantsRequestDto' is not null or undefined
            assertParamExists('addExamParticipants', 'addExamParticipantsRequestDto', addExamParticipantsRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addExamParticipantsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of stage participants with exam summary (status, best result, exam count). 
         * @summary List exam stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name, or email
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by participant exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamParticipants: async (certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamParticipants', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (examStatus) {
                localVarQueryParameter['examStatus'] = examStatus.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove participant from exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExamParticipant: async (certificationId: number, stageId: number, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('removeExamParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('removeExamParticipant', 'stageId', stageId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('removeExamParticipant', 'participantId', participantId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/participants/{participantId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamParticipantApi - functional programming interface
 * @export
 */
export const ExamParticipantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamParticipantApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds participants to the exam stage by their certification stage participant IDs. Employees without a passed TEST stage in this certification are not added — they are reported in `skippedItems` with `reason = TEST_NOT_PASSED` (the `identifier` is the source `participantId` that was supplied). 
         * @summary Add participants to exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddExamParticipantsRequestDto} addExamParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExamParticipants(certificationId: number, stageId: number, addExamParticipantsRequestDto: AddExamParticipantsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddStageParticipantsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExamParticipants(certificationId, stageId, addExamParticipantsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamParticipantApi.addExamParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of stage participants with exam summary (status, best result, exam count). 
         * @summary List exam stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name, or email
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by participant exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamParticipants(certificationId, stageId, page, pageSize, search, examStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamParticipantApi.getExamParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove participant from exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeExamParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeExamParticipant(certificationId, stageId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamParticipantApi.removeExamParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamParticipantApi - factory interface
 * @export
 */
export const ExamParticipantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamParticipantApiFp(configuration)
    return {
        /**
         * Adds participants to the exam stage by their certification stage participant IDs. Employees without a passed TEST stage in this certification are not added — they are reported in `skippedItems` with `reason = TEST_NOT_PASSED` (the `identifier` is the source `participantId` that was supplied). 
         * @summary Add participants to exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddExamParticipantsRequestDto} addExamParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExamParticipants(certificationId: number, stageId: number, addExamParticipantsRequestDto: AddExamParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto> {
            return localVarFp.addExamParticipants(certificationId, stageId, addExamParticipantsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of stage participants with exam summary (status, best result, exam count). 
         * @summary List exam stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Search by first name, last name, or email
         * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by participant exam status (CSV)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<ExamParticipantsResponseDto> {
            return localVarFp.getExamParticipants(certificationId, stageId, page, pageSize, search, examStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove participant from exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExamParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeExamParticipant(certificationId, stageId, participantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamParticipantApi - interface
 * @export
 * @interface ExamParticipantApi
 */
export interface ExamParticipantApiInterface {
    /**
     * Adds participants to the exam stage by their certification stage participant IDs. Employees without a passed TEST stage in this certification are not added — they are reported in `skippedItems` with `reason = TEST_NOT_PASSED` (the `identifier` is the source `participantId` that was supplied). 
     * @summary Add participants to exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddExamParticipantsRequestDto} addExamParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApiInterface
     */
    addExamParticipants(certificationId: number, stageId: number, addExamParticipantsRequestDto: AddExamParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddStageParticipantsResultDto>;

    /**
     * Returns paginated list of stage participants with exam summary (status, best result, exam count). 
     * @summary List exam stage participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Search by first name, last name, or email
     * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by participant exam status (CSV)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApiInterface
     */
    getExamParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<ExamParticipantsResponseDto>;

    /**
     * 
     * @summary Remove participant from exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApiInterface
     */
    removeExamParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ExamParticipantApi - object-oriented interface
 * @export
 * @class ExamParticipantApi
 * @extends {BaseAPI}
 */
export class ExamParticipantApi extends BaseAPI implements ExamParticipantApiInterface {
    /**
     * Adds participants to the exam stage by their certification stage participant IDs. Employees without a passed TEST stage in this certification are not added — they are reported in `skippedItems` with `reason = TEST_NOT_PASSED` (the `identifier` is the source `participantId` that was supplied). 
     * @summary Add participants to exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddExamParticipantsRequestDto} addExamParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApi
     */
    public addExamParticipants(certificationId: number, stageId: number, addExamParticipantsRequestDto: AddExamParticipantsRequestDto, options?: RawAxiosRequestConfig) {
        return ExamParticipantApiFp(this.configuration).addExamParticipants(certificationId, stageId, addExamParticipantsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of stage participants with exam summary (status, best result, exam count). 
     * @summary List exam stage participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Search by first name, last name, or email
     * @param {Array<ParticipantExamSummaryStatusDto>} [examStatus] Filter by participant exam status (CSV)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApi
     */
    public getExamParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, examStatus?: Array<ParticipantExamSummaryStatusDto>, options?: RawAxiosRequestConfig) {
        return ExamParticipantApiFp(this.configuration).getExamParticipants(certificationId, stageId, page, pageSize, search, examStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove participant from exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamParticipantApi
     */
    public removeExamParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig) {
        return ExamParticipantApiFp(this.configuration).removeExamParticipant(certificationId, stageId, participantId, options).then((request) => request(this.axios, this.basePath));
    }
}

